const w = (fn) => (state) => fn(state.assets);
export const openSelector = w((state) => state.open);
export const settingsSelector = w((state) => state.settings);
export const optionsSelector = w((state) => state.options);
export const lastAssetSelector = w((state) => state.lastAsset);
